import { render, staticRenderFns } from "./TracingDelayedTrucks.vue?vue&type=template&id=4c1ce5c1&scoped=true"
import script from "./TracingDelayedTrucks.vue?vue&type=script&lang=js"
export * from "./TracingDelayedTrucks.vue?vue&type=script&lang=js"
import style0 from "./TracingDelayedTrucks.vue?vue&type=style&index=0&id=4c1ce5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ce5c1",
  null
  
)

export default component.exports